<template>
  <v-dialog v-model="value" @click:outside="onClickOutside" width="400">
    <v-card>
      <v-card-text>
        <div class="popup-container">
          <p>You are sending a connection request to the Channel owner.</p>
          <form @submit.prevent="onSubmit">
            <div class="form-group">
              <textarea
                v-model="message"
                class="form-control"
                placeholder="Add an optional personal message..."
              ></textarea>
            </div>
            <div class="form-actions d-flex justify-content-between">
              <input type="submit" class="btn btn-primary" value="Send" />
              <input
                type="reset"
                class="btn btn-default"
                value="Cancel"
                @click="onClickCancel"
              />
            </div>
          </form>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    contentId: {
      type: String,
      default: "",
    },
    groupId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      message: "",
      memberCode: "",
    };
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
    resetForm() {
      this.message = "";
      this.memberCode = "";
    },
    onClickOutside() {
      this.close();
    },
    onSubmit() {
      const data = {
        contentId: this.contentId,
        groupId: this.groupId,
        message: this.message,
      };
      this.$repo.group
        .requestGroupContentApproval(data)
        .then((_) => {
          this.$toasted.show("Request has been sent.", {
            type: "success",
            duration: 3000,
            position: "bottom-center",
          });
          this.$emit("sent");
          this.resetForm();
          this.close();
        })
        .catch((_) => {
          this.$toasted.show(
            "Sorry, Something went wrong. Please try again later.",
            {
              type: "error",
              duration: 3000,
              position: "bottom-center",
            }
          );
        });
    },
    onClickCancel() {
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-container {
  padding: 30px 6px;
  font-size: 12px;

  textarea {
    height: 100px;
    font-size: 12px;
  }

  input {
    font-size: 12px;
  }

  .form-actions {
    input {
      width: 48%;
    }
  }
}
</style>